/* istanbul ignore file */
import { useI18N } from "@customer-tools-web/component-i18n";
import { useMarketConfig } from "@customer-tools-web/market-extension-resolver/lib/MarketConfigProvider";
import axios from "axios";
import * as React from "react";

import { usePlatform } from "../hooks";

const FOOTER_SERVER_URL =
  process.env.REACT_APP_FOOTER_SERVER_URL ||
  "https://header-footer-service.dev.core.iproperty.com.my/footer";

function fetchFooterHtml(
  locale: string,
  market: string,
  callback: (html: string) => void
) {
  const localeHost =
    location.origin ||
    `${location.protocol}//${location.host}${location.port && ":"}${
      location.port
    }`;
  const params = {
    lang: locale,
    market: market,
    hostname: localeHost,
    enableGTMTrack: false,
    disableResponsive: false,
  };
  axios.interceptors.request.use((config) => {
    delete config.headers?.common?.Accept;
    return config;
  });
  axios
    .get(FOOTER_SERVER_URL, { params })
    .then((res) => {
      if (res && res.data) {
        callback(res.data);
      }
    })
    .catch((err) => {
      console.error(err);
    });
}

function refershFooterScript() {
  const container = document.getElementById("footer");
  const script = container && container.querySelector("script");
  if (container && script) {
    const newScript = document.createElement("script");
    newScript.innerHTML = script.innerHTML;
    container.removeChild(script);
    container.appendChild(newScript);
  }
}

function FooterHtml() {
  const [state, setState] = React.useState({
    footerHtml: "",
    scriptRefreshed: false,
  });
  const { locale } = useI18N();
  const config = useMarketConfig();

  React.useEffect(
    () => {
      fetchFooterHtml(locale, config.footerMarket, (footerHtml) =>
        setState((prev) => ({
          footerHtml,
          scriptRefreshed: prev.scriptRefreshed,
        }))
      );
    },
    [locale] // only refetch when locale changes
  );

  React.useEffect(
    () => {
      if (!state.scriptRefreshed && state.footerHtml) {
        refershFooterScript();
        setState((prev) => ({
          footerHtml: prev.footerHtml,
          scriptRefreshed: true,
        }));
      }
    },
    [locale, state.footerHtml] // only refresh script when local or html changes
  );

  return <footer dangerouslySetInnerHTML={{ __html: state.footerHtml }} />;
}

export function Footer() {
  const { isMobilePlatform } = usePlatform();
  return isMobilePlatform ? null : <FooterHtml />;
}

export default Footer;
